export default {"src":"/_next/static/media/logo.7176e88b.svg","height":128,"width":128};